import React, { useState, useEffect } from 'react';
import {
  Button, Link, Typography, CircularProgress,
} from '@mui/material';
import { Link as RouterLink } from "react-router-dom";
import makeStyles from '@mui/styles/makeStyles';
import SSO from '../SSO';

function RedirectComponent() {
  useEffect(() => {
    window.location.href = 'https://www.symphony.com/support/developers/';
  }, []);

  return (
    <div>
      <p></p>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  titlePanel: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  title: {
    maxWidth: '45rem',
    padding: '0 2rem'
  },
  titleText: {
    color: '#fff',
    fontWeight: '700',
  },
  illustration: {
    width: '13rem',
    borderRadius: '50%',
    margin: '2rem'
  },
  actionPanel: {
    width: '100%',
    margin: '3rem 0',
    display: 'inline-flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    alignItems: 'flex-start',
    gap: '2rem'
  },
  actionItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '30rem',
    [theme.breakpoints.up('sm')]: {
      width: '20rem'
    }
  },
  actionText: {
    color: '#fff',
    fontWeight: '400',
    padding: '10px',
    textAlign: 'center'
  }
}));

export default RedirectComponent;

/*
export default () => {
  const classes = useStyles();
  const { launchSso } = SSO();
  const [ loading, setLoading ] = useState(false);

  const items = [
    {
      name: 'Developer Forum',
      text: 'Get started with discussions',
      ssoSite: 'forum',
    },
    {
      name: 'Events',
      text: 'Join our upcoming events or watch recordings of past events on-demand',
      to: '/events',
    },
    {
      name: 'Developer Newsletter',
      text: 'Subscribe to our newsletter or read past entries',
      href: '//goto.symphony.com/developer-newsletter-archive?from=developers',
    },
    {
      name: 'Developer Blog',
      text: 'Read our latest blog posts and stay updated',
      href: '//symphony.com/resource/blog/?type=developers',
    },
  ];

  const ActionItem = ({ name, text, href, to, ssoSite }) => {
    let buttonProps = {};
    if (href) {
      buttonProps = { href, component: Link, target: '_blank', rel: 'noopener' };
    } else if (to) {
      buttonProps = { to, component: RouterLink, };
    } else if (ssoSite) {
      buttonProps = {
        disabled: loading,
        onClick: () => launchSso(ssoSite, setLoading),
        endIcon: loading ? <CircularProgress size={10} /> : '',
      };
    }

    return (
      <div className={classes.actionItem}>
        <Button variant="blue" {...buttonProps}>
          {name}
        </Button>
        <Typography className={classes.actionText}>
          {text}
        </Typography>
      </div>
    );
  };

  return (
    <>
      <div className={classes.titlePanel}>
        <img src="community-illus.png" className={classes.illustration} alt="Community" />
        <div className={classes.title}>
          <Typography component="h6" className={classes.titleText}>
            This is where the community comes together! Ask and answer questions, have open-ended conversations, learn how to build bots in seconds and stay up to date with Symphony Developer news.
          </Typography>
        </div>
      </div>
      <div className={classes.actionPanel}>
        {items.map(item => <ActionItem key={item.name} {...item} />)}
      </div>
    </>
  )
};
*/
